import type { ChatMessage } from "../types";

type Props = {
  message: ChatMessage;
};

export function AIChatUserBubble({ message }: Props) {
  return (
    <div className="flex flex-col items-end gap-1">
      <div className="max-w-[min(100%,36rem)] rounded-2xl rounded-br-md bg-primary px-4 py-2.5 text-sm leading-6 text-white shadow-sm">
        {message.text}
      </div>
      <span className="pr-1 text-[11px] text-[#9CA3AF]">{message.time}</span>
    </div>
  );
}
